module.exports = __webpack_public_path__ + "static/img/200078.0c728ceb.png";